export const typeBienOptions = [
  { value: 'immeuble', label: 'Immeuble' },
  { value: 'appartement', label: 'Appartement' },
  { value: 'maison', label: 'Maison' },
  { value: 'autre', label: 'Autre' }
]

export const typeMandatOptions = [
  { value: "", label: "Aucun mandat" },
  { value: "location", label: "Location" },
  { value: "vente", label: "Vente" }
]